import completeSound from "../assets/complete.mp3";
import swishSound from "../assets/swish.mp3";
import Logger from "./Logger";
const SOUND_ENABLED_KEY = "soundEnabled";
const audioCache = {};
export function isSoundEnabled() {
    try {
        return window.localStorage.getItem(SOUND_ENABLED_KEY) !== "false";
    }
    catch (e) {
        return true;
    }
}
export function setSoundEnabled(enabled) {
    try {
        window.localStorage.setItem(SOUND_ENABLED_KEY, enabled ? "true" : "false");
    }
    catch (e) {
        Logger.error(e);
    }
}
/**
 * Never throws: a blocked or unsupported audio device must not get in the way of the
 * action that triggered the sound. Call it synchronously from a user gesture handler (iOS Safari).
 */
function play(src) {
    if (typeof Audio === "undefined" || !isSoundEnabled()) {
        return;
    }
    try {
        if (audioCache[src] == null) {
            audioCache[src] = new Audio(src);
        }
        const audio = audioCache[src];
        audio.currentTime = 0;
        const result = audio.play();
        if (result !== undefined) {
            result.catch((e) => Logger.error(e));
        }
    }
    catch (e) {
        Logger.error(e);
    }
}
export function playCompleteSound() {
    play(completeSound);
}
export function playSnoozeSound() {
    play(swishSound);
}
